import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FinanceVP, RefundDetails, Transaction, Period, RefundDetailsModel, Calendar } from '@accountexecutivemodel/AccountExecutive';
import { AccountExecutiveService } from '@accountexecutiveservice/account-executive.service';
import { authManager } from '@authmanager/authManager';
//import { Angular2Csv } from 'angular2-csv/angular2-csv';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { HttpClient } from '@angular/common/http';
import { AdminService } from '@adminservice/admin.service';
import { DatePipe } from '@angular/common';
//   for checkbox
import { SelectedRecords, TransactionHistory, SaveTransaction } from '@externalusermodel/Order';
//   date calender
import { DatePickerModule } from 'primeng/datepicker';
import { Table } from 'primeng/table';
import { EMPTY } from 'rxjs';
import { Alert, Key } from '../../../node_modules/@types/selenium-webdriver';
import { ppid } from 'process';


@Component({
    selector: 'app-account-executive',
    templateUrl: './account-executive.component.html',
    styleUrls: ['./account-executive.component.css'],
    providers: [AccountExecutiveService, AdminService],
    standalone: false
})
export class AccountExecutiveComponent implements OnInit {
  //version migration
  activeTab = 'transactions'; // Default active tab
  // version migration end
  financeVP: any;
  financeVPs: FinanceVP[];
  refund: RefundDetails[];
  currentTrancationID: any;
  originalapprovalCode;any
  displayAddRefundPopUp: any;
  RefundSubmitBtn: boolean;
  refundAmount: any;
  refundComments: any;
  selectedFinanceVP: any;
  refundUpdatedstatus: string;
  invalidRefundAmnt: boolean;
  invalidAdvRefundAmnt: boolean;
  invalidComments: boolean;
  invalidFinanceVP: boolean;
  disableAddRefundBtn: boolean;
  SelectPeriod: any;
  transaction: Transaction[] = [];
  headerArray: any[] = [];
  amountPaid: any;
//   for adding Agency comm in transa report
//agencyCommissionPerc :any;
  agencyCommission : any;
  advanceTax : any;
  tax : any;
  //   partialPayment
  partialPayment:any;
  orderInvoiceAmount: any;
  UserID: any;
  hideColums: boolean;
  hiderefund: boolean;
  Period: any;
  //   Date search
  Calendar: Date;
  value1: Date;
  value2: Date;
  transactionbydate: Transaction[] = [];
  Validateenddate: boolean;
  Validateendnulldate: boolean;
  // end   Date search
  updatedRefundRow: any = {};
  OrderID: any;
  InvoiceID: any;
  OrderInvoiceDate: any;
  Agency: any;

  Advertiser: any;
  TransID: any;

  LognewUser: any = {};
  UserLog: string;
  require: any;
  LnewUser: any = {};
  UserLogStatus: any = [];
  reviseRefundTextCont = 'Revised';
  noRecord: boolean;
  newComments: string;
  CommentsDetails: any = [];
  CommentsModel: any = {};
  saveStatus: string;
  refundDetailsID: number;
  RefundDetailsModel: any = [];
  displayCommentsPopUp: any;
  invalidCMComments: boolean;
  StatusApproval: string;
  refundDetailIDRevised: number;
  commentsPopupTitle: string;
//   Date search
loadingTransactiondate: boolean;
// End  
  loadingTransaction: boolean;
  loadingRefund: boolean;
  type: any;
  paymentTransType: any;

  refundCalcAmount: any;
  isPartialPayment: any;
  advancePaymentAmount: any;
  invalidAdvGrossRefundAmnt: boolean;
  //  ApprovalCode
  ApprovalCode: string;
  ledgerAmount :any;
  //   Agency Tcode
  agencyTcode: string;
  //   Advertiser to code Tcode
  advertiserTcode: string;
  //   1234 checkbox
  SavetransBtn: boolean;
  isFilterEnable: boolean;
  enableInvoiceFilter: boolean;
  selectedTransactionMap: Map<string, SaveTransaction> = new Map<string, SaveTransaction>();
  isshowtransChecked: boolean;
  selection;
  HeaderCheckbox: any;

  isSelectedMultipleInovice: boolean = false;

  TransactionFilterFields:any =['type','paymentSettlementDate','sapPostingDate','agency','agencyTcode','advertiser','advertiserTcode','orderID','invoiceID','orderInvoiceAmount','amountPaid','ledgerAmount','stations','comments','approvalCode','paymentTransType','partialPayment','agencyCommission','tax','balanceAmount','paymentCustomerProfile','status','transactionType','paymentTransID','orderInvoiceDate','userID','cardNo','orderInvoiceDateSortable','paidBy','paymentSettlementDateSortable','paymentBatchID','chaseTransactionDate','chaseStatus','createdDate','isProcessed','originalApprovalCode'];
  RefundFilterFields:any =[
    'accountExecutiveComments',
    'advancePaymentAmount',
    'advertiserName',
    'agencyName',
    'agencyTcode',
    'amountPaid',
    'approvalCode',
    'approvalStatus',
    'cardNo',
    'cmAdminComments',
    'cmComments',
    'creditManagerComments',
    'invoiceID',
    'isPartialPayment',
    'orderId',
    'orderInvoiceAmount',
    'orderInvoiceDate',
    'orderInvoiceDateSortable',
    'originalApprovalCode',
    'paymentTransID',
    'paymentTransType',
    'refundAmount',
    'refundDetailID',
    'transID',
    'type'
  ];

  selectedAll: any;
  Saveselectedtransitems:any = [];
  //transactionGlobalFilter: string = '';
  @ViewChild('dtTransaction',{ static: false }) dtTransaction!: any;

  //   end dtTrans
  @ViewChild('dtRefund', { static: false }) private refundTable: any;
  @ViewChild('dtTrans', { static: false }) private transactionTable: Table;
  public paddingCells: any = {
    background: '#ff0000',
    textAlign: 'center'
  };
  enableFilter: boolean;

  constructor(private accountExecutiveService: AccountExecutiveService, private authManagerService: authManager,
    private http: HttpClient, private adminService: AdminService, public datepipe: DatePipe, private cdr: ChangeDetectorRef) {
    this.hiderefund = false;
    this.noRecord = true;
    this.enableFilter = false;
    this.Validateenddate = true;
    this.Validateendnulldate = true;

  }

  ngOnInit() {

    // Internal User
    if (sessionStorage.getItem('userRoleId') !== '0') {
      this.UserID = sessionStorage.getItem('userid');
      this.hideColums = false;   // to show all columns
      // this.headerArray = ['Type', 'Transaction Type', 'Transaction Date', 'Flight Start Date/ Invoice Date', 'Order ID', 'Invoice ID',
      //   'Transaction ID', 'Agency', 'AgencyTcode', 'Advertiser', 'Stations', 'Customer Name', 'Comments', 'Payment Transaction Type', 'Payment Card No.', 'Invoice/Order (Cash disc. price) $', 'Payment Received',
      //   'Refund Balance', 'Payment Customer Profile','Payment Status', 'Status','Approval Code','Partial Amount','Agency Commission %','Tax %'];//   'Approval Code',   Partial Amount and AgencyCommission %
      this.headerArray = ['Type', 'Transaction Date','SAP Posting Date','Agency', 'AgencyTcode', 'Advertiser','AdvertiserTcode','Order ID', 'Invoice ID','Invoice/Order (Cash disc. price) $', 'Payment Received',
      'Ledger Amount','Stations', 'Comments','Approval Code', 'Payment Transaction Type','Partial Amount','Agency Commission %','Tax %',
      'Refund Balance', 'Payment Customer Profile', 'Status','Transaction Type','Transaction ID','Flight Start Date/ Invoice Date', 'Payment Card No.', 'Customer Name','Payment Status']
     
      if (sessionStorage['userRoleId']) {
        if (sessionStorage.getItem('userRoleId') === '1' || sessionStorage.getItem('userRoleId') === '4') {
          this.hiderefund = true; // hiding the refund tab for admin and CM admin
        } else {
          this.hiderefund = false;
        }
      }

    } else {
      // external user
      this.UserID = sessionStorage.getItem('userid');
      this.hideColums = true; // to hide some columns for external user
      // this.headerArray = ['Type', 'Transaction Type', 'Transaction Date', 'Flight Start Date/ Invoice Date', 'Order ID', 'Invoice ID',
      //   'Transaction ID', 'Agency', 'AgencyTcode', 'Advertiser','AdvertiserTcode', 'Stations', 'Customer Name', 'Comments', 'Payment Transaction Type', 'Invoice/Order (Cash disc. price) $', 'Payment Received',
      //   'Payment Status', 'Status'];

        this.headerArray = ['Type','Transaction Date', 'AgencyTcode','Agency', 'Advertiser','AdvertiserTcode', 'Order ID', 'Invoice ID', 'Invoice/Order (Cash disc. price) $', 'Payment Received',
        'Stations','Comments','Approval Code','Payment Transaction Type','Partial Amount', 'Agency Commission %','Tax %', 'Status','Transaction Type', 'Transaction ID',
         'Flight Start Date/ Invoice Date', 'Customer Name',
        'Payment Status'];


      this.hiderefund = true; // hiding the refund tab from external users
    }
    this.Period = Period.All;
    this.LoadRefund(); // Method to load Refund Table
    this.LoadTransaction(this.isshowtransChecked); // Method to load Transaction table

    this.invalidRefundAmnt = true;
    this.invalidAdvRefundAmnt = true;
    this.invalidAdvGrossRefundAmnt = true;
    this.invalidComments = true;
    this.invalidCMComments = true;
    // this.invalidCreditManager = true;
    this.invalidFinanceVP = true;
    this.SelectPeriod = Period.SelectPeriod;

    this.saveIP();

  }

  // ngAfterViewInit() {
  //   this.initializeFilterConstraints();
  // }

  // private initializeFilterConstraints(retries: number = 5) {
  //   if (this.refundTable && this.refundTable.filterConstraints) {
  //     this.refundTable.filterConstraints['inv_invDate'] = (value: Date | string, filter: [Date, Date]): boolean => {
  //       let startDate: Date = new Date(this.datepipe.transform(filter[0], 'yyyy-MM-dd') as string);
  //       let endDate: Date = new Date(this.datepipe.transform(filter[1], 'yyyy-MM-dd') as string);
  //       let rowDate: Date = new Date(value);
  //       return rowDate >= startDate && rowDate <= endDate;
  //     };
  //   } else if (retries > 0) {
  //     setTimeout(() => this.initializeFilterConstraints(retries - 1), 100); // Retry after 100ms
  //   } else {
  //     console.warn('refundTable or filterConstraints is not initialized after retries.');
  //   }
  //   this.cdr.detectChanges(); // Ensure view updates
  // }

  // Method to Load Refund Table
  LoadRefund() {
    this.loadingRefund = true;
    this.accountExecutiveService.getRefundDetails().subscribe(
      p => {
        this.refund = p;
        console.log('Refund data:', this.refund); // Debug line
        this.loadingRefund = false;
      }
    );
  }
  // Method to Load Transaction Table
  LoadTransactiondatesearch(isshowtransChecked) {
//debugger;
    if (this.isshowtransChecked === undefined)
    {
     this.isshowtransChecked = false;
    }
   // debugger;
    this.loadingTransactiondate = true;
   // debugger;
    if(this.value2 == null)
    {
      this.value2 = new Date();
    }
    this.accountExecutiveService.getTransactionDetailsDate(this.UserID, this.value1, this.value2,this.isshowtransChecked).subscribe(
      p => {
        this.transaction = p;
        console.log('Transaction data by date:', Array.isArray(this.transaction)) // should be true); // Debug line
        if (this.transaction.length === 0) {
          this.noRecord = false;
        }
       //  debugger;
       // this.loadingTransactiondate = false;
      });
      //debugger; 
     // this.value1 = null;
     // this.value2 = null;
  }
ValidateToDate(){
//debugger
if (this.value2 < this.value1)
{
  this.Validateenddate = false;
}
else{
  this.Validateenddate = true;
}
  }
  // Method to Load Transaction Table
  LoadTransaction(isshowtransChecked) {
    this.loadingTransaction = true;
    this.accountExecutiveService.getTransactionDetails(this.UserID, this.Period, this.isshowtransChecked).subscribe(
      p => {
        this.transaction = p;
        console.log('Transaction data:', this.transaction); // Debug line
        if (this.transaction.length === 0) {
          this.noRecord = false;
        }
        // debugger;
        for (let data in this.transaction) {
          if (this.transaction.hasOwnProperty(data)) {
            delete this.transaction[data].createdDate;
            delete this.transaction[data].userID;
            //delete this.transaction[data].Isprocessed;
            // delete this.transaction[data].PaymentBatchID;
            if (sessionStorage['Userid']) {
              delete this.transaction[data].cardNo;
              delete this.transaction[data].PaymentCustomerProfile;
              // delete this.transaction[data].paymentSettlementDate;
              delete this.transaction[data].balanceAmount;
              //  delete this.transaction[data].PaymentBatchID;
             
            }
          }
        }
        this.loadingTransaction = false;
      });
  }
  // Transaction Report Generation
  DownloadTransactionReport() {

    let reportData = JSON.parse(JSON.stringify(this.transaction));
    for (let data in reportData) {
      if (reportData.hasOwnProperty(data)) {
        delete reportData[data].orderInvoiceDateSortable;
        delete reportData[data].paymentSettlementDateSortable;
        delete reportData[data].chaseTransactionDate;
        delete reportData[data].paymentBatchID;
        delete reportData[data].isprocessed;
        //  1234 Download report change on date search
        delete reportData[data].userID;
        delete reportData[data].createdDate;
        //   1234
        delete  reportData[data].isProcessed;
        // delete reportData[data].paymentCustomerProfile;
        if (sessionStorage.getItem('userRoleId') === '0') {
          delete reportData[data].cardNo;
          delete reportData[data].balanceAmount;
          //  ApprovalCode
          delete reportData[data].ApprovalCode;
          //  agencyTCode
          delete reportData[data].agencyTcode;
          // delete reportData[data].paymentSettlementDate;
          delete reportData[data].paymentBatchID;

          delete reportData[data].paymentCustomerProfile;
          delete reportData[data].ChaseTransactionDate;
        }

        if (reportData[data].type === "") {
          delete reportData[data].amountPaid;
          delete reportData[data].balanceAmount;
          delete reportData[data].orderInvoiceAmount;
          //   partialPayment
          delete reportData[data].partialPayment;
          //   for Agency commission in transanction report.
         // delete reportData[data].agencyCommissionPerc;
         delete reportData[data].agencyCommission;
         delete reportData[data].tax;
         delete reportData[data].stations;
        }
      }
    }
    let options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: true,
      paddingCellOptions: this.paddingCells,
      title: 'MediaPay - Transactions Report',
      useBom: true,
     // noDownload: true,
      headers: this.headerArray
    };
    debugger;
    let DownloadTransactionReport = new ngxCsv (reportData, 'Transactions Report', options);
  }



  // Method to add refund
  AddRefund(row) {
     debugger;
    this.displayAddRefundPopUp = true;
    // To Load Credit manager drop down data
    this.accountExecutiveService.getFinanceVPs().subscribe
      (p => {
        this.financeVPs = p;
        // console.log(this.financeVPs)
      });
    this.type = row.type;
    this.paymentTransType = row.paymentTransType;
    this.currentTrancationID = row.paymentTransID;
    debugger;
    this.originalapprovalCode=row.approvalCode;
    this.OrderID = row.orderId;
    this.InvoiceID = row.invoiceID;
    this.OrderInvoiceDate = row.orderInvoiceDate;
    this.Agency = row.agencyName.agencyID;
    // comment to fix the refund page issue.10/23
    //this.Advertiser = row.advertiserName.advertiserID;
    this.TransID = row.transID;
    this.amountPaid = row.amountPaid;
    this.orderInvoiceAmount = row.orderInvoiceAmount;
    this.StatusApproval = row.approvalStatus;
    this.refundDetailsID = row.refundDetailID
    this.isPartialPayment = row.isPartialPayment;
    this.invalidRefundAmnt = true;
    this.invalidAdvRefundAmnt = true;
    this.invalidAdvGrossRefundAmnt = true;
    this.invalidComments = true;
    //  for original approval code .
    debugger;
    this.originalapprovalCode= row.approvalCode;
    this.advancePaymentAmount = row.advancePaymentAmount;
    // this.invalidCreditManager = true;
    this.invalidFinanceVP = true;
    if (this.StatusApproval == this.reviseRefundTextCont) {
      this.commentsPopupTitle = 'Revise Refund';
    }
    else {
      this.commentsPopupTitle = 'Add Refund';
    }

  }
  onRefundSubmitCalculation(AddRefundFrm) {
    if (this.OrderID === '') {
      this.OrderID = null;
    }
    else if (this.InvoiceID === '') {
      this.InvoiceID = null;
    }

    if (this.paymentTransType === 'CC') {
      this.accountExecutiveService.getRefundCalculation(this.refundAmount, this.paymentTransType, this.type, this.InvoiceID, this.OrderID).subscribe(
        p => {
          this.refundCalcAmount = p;
          this.onRefundSubmit(AddRefundFrm);
        }
      );

    }
    else {
      this.onRefundSubmit(AddRefundFrm);
    }

  }

  // Method to submit refund
  onRefundSubmit(AddRefundFrm) {
    // debugger;

    if (AddRefundFrm.valid) {
      // Refund Amount validation
      if (this.type === 'Advance' && this.refundAmount === 0 && this.paymentTransType === 'ACH') {
        this.invalidAdvRefundAmnt = false;
      }
      else if (this.type === 'Advance' && this.refundAmount === 0 && this.paymentTransType === 'CC') {
        this.invalidAdvGrossRefundAmnt = false;
      }
      else if (this.type !== 'Advance' && this.refundAmount === 0 && this.isPartialPayment === false) {
        this.invalidRefundAmnt = false;
      }
      else if (this.type !== 'Advance' && this.refundAmount === 0 && this.isPartialPayment === true) {
        this.invalidAdvRefundAmnt = false;
      }
      else {
         //  for refund change. chnage this.invalidRefundAmnt = false to true;.
        if (this.type !== 'Advance' && this.orderInvoiceAmount < this.refundAmount && this.isPartialPayment === false) {
          //this.invalidRefundAmnt = false;
          this.invalidRefundAmnt = true;
        }
        else if (this.type !== 'Advance' && this.amountPaid < this.refundAmount && this.isPartialPayment === true) {
          this.invalidAdvRefundAmnt = false;
        }
        else if (this.type === 'Advance' && this.amountPaid < this.refundAmount && this.paymentTransType === 'ACH') {
          this.invalidAdvRefundAmnt = false;
        }
        //  for refund change. commented below line for CC.
        // else if (this.type === 'Advance' && this.advancePaymentAmount < this.refundAmount && this.paymentTransType === 'CC') {
        //   this.invalidAdvGrossRefundAmnt = false;
        // }
        else if (this.refundAmount < 0 && this.type !== 'Advance' && this.isPartialPayment === false) {
          this.invalidRefundAmnt = false;
        }
        else if (this.refundAmount < 0 && this.type !== 'Advance' && this.isPartialPayment === true) {
          this.invalidAdvRefundAmnt = false;
        }
        else if (this.refundAmount < 0 && this.type === 'Advance' && this.paymentTransType === 'ACH') {
          this.invalidAdvRefundAmnt = false;
        }
        else if (this.refundAmount < 0 && this.type === 'Advance' && this.paymentTransType === 'CC') {
          this.invalidAdvGrossRefundAmnt = false;
        }
        else {
          if (this.type !== 'Advance' && this.isPartialPayment === false) {
            this.invalidRefundAmnt = true;
          }
          else {
            this.invalidAdvGrossRefundAmnt = true;
            this.invalidAdvRefundAmnt = true;
          }

        }
      }
      // ends

      // refund amount validation
      if (this.refundComments.trim().length === 0) {
        this.invalidComments = false;
      } else { this.invalidComments = true; }
      // ends

      // credit manager validation
      if (AddRefundFrm.controls.financeVP.valid) {
        this.invalidFinanceVP = true;
      }
      // ends

      if (this.invalidFinanceVP === true && this.invalidComments === true && this.invalidRefundAmnt === true && this.invalidAdvRefundAmnt === true && this.invalidAdvGrossRefundAmnt === true) {
        if (this.refundDetailsID != null) {
          this.updatedRefundRow.refundDetailID = this.refundDetailsID;
        }
        this.updatedRefundRow.OrderID = this.OrderID;
        this.updatedRefundRow.InvoiceID = this.InvoiceID;
        this.updatedRefundRow.PaymentTransID = this.TransID;

        this.updatedRefundRow.CreditManagerID = this.selectedFinanceVP.id;
        this.updatedRefundRow.OrderInvoiceDate = this.OrderInvoiceDate;
        this.updatedRefundRow.AgencyID = this.Agency;
        this.updatedRefundRow.AdvertiserID = this.Advertiser;
        this.updatedRefundRow.RefundApproved = 0;
        if (this.paymentTransType === 'CC') {
          this.updatedRefundRow.RefundAmount = this.refundCalcAmount;
        }
        else {
          this.updatedRefundRow.RefundAmount = this.refundAmount;
        }

        this.updatedRefundRow.ApprovalStatus = 'Submitted';
        this.updatedRefundRow.AccountExecutiveComments = this.refundComments;
        this.updatedRefundRow.CreatedDate = new Date();
        this.updatedRefundRow.CreatedBy = this.UserID;
        this.updatedRefundRow.RoleID = Number(sessionStorage.getItem('userRoleId'));
        this.updatedRefundRow.ActionID = 4;
        //  Added to save aproval code to use as original approval code.
        debugger;
        this.updatedRefundRow.OriginalApprovalCodeForRefund= this.originalapprovalCode;
        this.accountExecutiveService.saveRefundDetails(this.updatedRefundRow, this.TransID)
          .subscribe((status) => {
            this.refundUpdatedstatus = status;
            // console.log(this.refundUpdatedstatus);
            // console.log("Saved");
            this.LoadRefund();
            if (this.refundUpdatedstatus === 'Success') {
              this.resetForm(AddRefundFrm);
            }
          });
        this.displayAddRefundPopUp = false;
      }
    } else {

      // Finance VP validation
      if (!AddRefundFrm.controls.financeVP.valid) {
        this.invalidFinanceVP = false;
      } else { this.invalidFinanceVP = true; }
      // ends

      // Refund Amount Validation
      if (!AddRefundFrm.controls.refundAmount.valid && this.type !== 'Advance' && this.isPartialPayment === false) {
        this.invalidRefundAmnt = false;
      } else if (!AddRefundFrm.controls.refundAmount.valid && this.type !== 'Advance' && this.isPartialPayment === true) {
        this.invalidAdvRefundAmnt = false;
      }
      else if (AddRefundFrm.controls.refundAmount.valid && this.type !== 'Advance' && this.isPartialPayment === false) {
        if (this.refundAmount === 0) {
          this.invalidRefundAmnt = false;
        } else if (this.refundAmount < 0) {
          this.invalidRefundAmnt = false;
        } 
        //  Comment for refund and change the logic condition
        // else if (this.orderInvoiceAmount < this.refundAmount) {
        //   this.invalidRefundAmnt = false;
       // } 
        else { this.invalidRefundAmnt = true; }
      }
      else if (AddRefundFrm.controls.refundAmount.valid && this.type !== 'Advance' && this.isPartialPayment === true) {
        if (this.refundAmount === 0) {
          this.invalidAdvRefundAmnt = false;
        } else if (this.refundAmount < 0) {
          this.invalidAdvRefundAmnt = false;
        } else if (this.amountPaid < this.refundAmount) {
          this.invalidAdvRefundAmnt = false;
        } else {
          this.invalidAdvRefundAmnt = true;
        }
      }
      else if (!AddRefundFrm.controls.refundAmount.valid && this.type === 'Advance' && this.paymentTransType === 'ACH') {
        this.invalidAdvRefundAmnt = false;
      } else if (!AddRefundFrm.controls.refundAmount.valid && this.type === 'Advance' && this.paymentTransType === 'CC') {
        this.invalidAdvGrossRefundAmnt = false;
      }
      else if (AddRefundFrm.controls.refundAmount.valid && this.type === 'Advance') {
        if (this.refundAmount === 0 && this.paymentTransType === 'ACH') {
          this.invalidAdvRefundAmnt = false;
        } else if (this.refundAmount === 0 && this.paymentTransType === 'CC') {
          this.invalidAdvGrossRefundAmnt = false;
        } else if (this.refundAmount < 0 && this.paymentTransType === 'ACH') {
          this.invalidAdvRefundAmnt = false;
        } else if (this.refundAmount < 0 && this.paymentTransType === 'CC') {
          this.invalidAdvGrossRefundAmnt = false;
        } else if (this.amountPaid < this.refundAmount && this.paymentTransType === 'ACH') {
          this.invalidAdvRefundAmnt = false;
        } else if (this.advancePaymentAmount < this.refundAmount && this.paymentTransType === 'CC') {
          this.invalidAdvRefundAmnt = true;
          this.invalidAdvGrossRefundAmnt = false;
        }
        else {
          this.invalidAdvRefundAmnt = true;
          this.invalidAdvGrossRefundAmnt = true
        }
      }
      // ends

      // Refund Comments Validation
      if (!AddRefundFrm.controls.refundComments.valid) {
        this.invalidComments = false;
      } else {
        if (this.refundComments === '' || this.refundComments.trim().length === 0) {
          this.invalidComments = false;
        } else { this.invalidComments = true; }
      }
      // ends

    }

  }
  // Method to reset form
  resetForm(AddRefundFrm) {
    for (let name in AddRefundFrm.controls) {
      if (AddRefundFrm.controls.hasOwnProperty(name)) {
        AddRefundFrm.controls[name].reset();
      }
    }
  }

  // Method to cancel Refund pop up
  onRefundSubmitCancel() {
    this.displayAddRefundPopUp = false;
    this.invalidFinanceVP = true;
    this.invalidComments = true;
    this.invalidRefundAmnt = true;
    this.invalidAdvRefundAmnt = true;
    this.invalidAdvGrossRefundAmnt = true;
  }

  onClickPeriod(period) {
    // debugger;

    if (period === 3) {
      this.SelectPeriod = Period.ThreeMonths;
      this.Period = 3;
    }
    if (period === 6) {
      this.SelectPeriod = Period.SixMonths;
      this.Period = 6;
    }
    if (period === 1) {
      this.SelectPeriod = Period.OneYear;
      this.Period = 1;
    }
    if (period === 0) {
      this.SelectPeriod = Period.SelectPeriod;
      this.Period = Period.All;
    }
    this.LoadTransaction(this.isshowtransChecked);
  }

  saveIP() {

    this.http.get<{ ip: string }>('https://api.ipify.org?format=json')
      .subscribe(data => {
        this.LognewUser.IPAddress = data.ip;
        this.LognewUser.LoginTime = new Date();
        const { detect } = require('detect-browser');
        const browser = detect();
        this.LognewUser.Browsertype = browser.name;
        this.LognewUser.BrowserVersion = browser.version;
        this.LognewUser.SSO = this.authManagerService.dynSSOId;
        this.LognewUser.FirstName = this.authManagerService.dynFirstName;
        this.LognewUser.LastName = this.authManagerService.dynLastName;
        this.LognewUser.Active = 1;
        this.LognewUser.userID = sessionStorage.getItem('userid');
        this.adminService.searchUser(this.LognewUser.userID, this.LognewUser.IPAddress, this.LognewUser.Browsertype)
          .subscribe((logStatus) => {
            this.UserLogStatus = logStatus;
            if (this.UserLogStatus === 'Success') {

              this.adminService.LogNewUserDetails(this.LognewUser)
                .subscribe((newLogStatus) => { this.UserLogStatus = newLogStatus; });
            } else {
              this.LnewUser.IPAddress = this.LognewUser.IPAddress;
              this.LnewUser.Browsertype = this.LognewUser.Browsertype;
              this.LnewUser.LogOutTime = new Date();
              this.LnewUser.Active = 0;
              this.LnewUser.SSO = this.authManagerService.dynSSOId;
              this.LognewUser.userID = this.LognewUser.userID;
              this.adminService.LogUserUpdateDetails(this.LnewUser)
                .subscribe((updateLogStatus) => { this.UserLogStatus = updateLogStatus; });

              this.adminService.LogNewUserDetails(this.LognewUser)
                .subscribe((status) => { this.UserLogStatus = status; });
            }
          });
      }, error =>
          console.error(error));
  }

  filterToggle(event) {
    this.enableFilter === false ? this.enableFilter = true : this.enableFilter = false;
    if (!this.enableFilter) {
      this.refundTable.reset();
    }
  }

  filtertransactionToggle(event) {
    this.enableFilter === false ? this.enableFilter = true : this.enableFilter = false;
    if (!this.enableFilter) {
      this.transactionTable.reset();
    }
  }



  // CM Comments Load Method starts
  GetComments(refundDetailsID: any) {

    this.invalidCMComments = true;
    this.displayCommentsPopUp = true;
    this.refundDetailsID = refundDetailsID;
    this.accountExecutiveService.getComments(refundDetailsID).subscribe(
      p => { this.CommentsDetails = p }
    );
  }
  // CM Comments Load Method ends

  // CM Comments Add Method starts
  AddNewComments() {
    if (this.newComments === undefined || this.newComments === '' || this.newComments.trim().length === 0) {
      this.invalidCMComments = false;
    }
    else { this.invalidCMComments = true; }
    if (this.invalidCMComments === true) {
      this.CommentsModel.refundDetailsID = this.refundDetailsID;
      this.CommentsModel.userID = sessionStorage.getItem('userid');
      this.CommentsModel.actionID = 4;
      this.CommentsModel.RoleID = sessionStorage.getItem('userRoleId');
      this.CommentsModel.Comments = this.newComments
      this.accountExecutiveService.saveComments(this.CommentsModel).subscribe(
        status => {
          this.saveStatus = status;
          if (this.saveStatus === 'Success') {

            this.GetComments(this.refundDetailsID);
            this.newComments = '';
          }
        }
      );
    }
    else {
      if (this.newComments === undefined || this.newComments === '' || this.newComments.trim().length === 0) {
        this.invalidCMComments = false;
      }
      else { this.invalidCMComments = true; }
    }
    // CM Comments Add Method ends

  }
  // CM Comments Cancel Method starts
  onCommentsCancel() {
    this.displayCommentsPopUp = false;
    this.invalidCMComments = false;
    this.newComments = '';
    this.LoadRefund();
  }
  // CM Comments Cancel Method ends
//   changes for Date search
  OnClickdate() {
    debugger;
    this.ValidateToDate();
    this.LoadTransactiondatesearch(this.isshowtransChecked);
  }
    //   1234
  onRowTransactionUnselect(event) {
//debugger;
     if (this.selectedTransactionMap.has(event.data.PaymentTransID)) {
       let loopStatus = 1;
     this.selectedTransactionMap.delete(event.data.PaymentTransID);
     this.selectedTransactionMap.forEach((value: SaveTransaction, key: any) => {
            });
	   }
   if (this.selectedTransactionMap.size === 0) {
      this.SavetransBtn = false;
   }
  }
  // Arivnd 1234 save transaction
  OnClickSaveTrans() {
   // debugger;
    let selectedTransaction: any = [];
    console.log("selectedTransaction 1", selectedTransaction);
      this.selectedTransactionMap.forEach((value: SaveTransaction) => {
         selectedTransaction.push(value);
    });
    console.log("selectedTransaction 2", selectedTransaction);
    this.accountExecutiveService.saveTransaction(selectedTransaction).subscribe(
      p => {
        this.LoadTransaction(this.isshowtransChecked); // Method to load Transaction table
        //this.router.navigate(['InvoiceDetail', p]);
        this.Saveselectedtransitems= [];
        this.SavetransBtn = false;
        //var ryt = document.getElementById(this.HeaderCheckbox);
        //if()
      }
    );
   // debugger;
  }
  // Arivnd 1234 for check box.
  TransactionFilterToggle(event) {
    this.isFilterEnable = !this.isFilterEnable;
    console.log(this.isFilterEnable);
    this.enableInvoiceFilter === false ? this.enableInvoiceFilter = true : this.enableInvoiceFilter = false;
    if (!this.enableInvoiceFilter) {
      //this.transaction.reset();
      // this.isInvoice_InvoiceFilterEndDateDisabled = true;
      //  this.isInvoice_DueFilterEndDateDisabled = true;
    }
  }
  //   1234 for transaction grid
  transactionHeaderCheckBoxToggle(selectedItems) {
   // debugger;
    this.SavetransBtn = false;
    if (this.selectedTransactionMap.size > 0) {
      this.selectedTransactionMap.clear();
    }
    if (selectedItems.length > 0) {
      selectedItems.forEach(element => {
        if (element.status == "Payment Processing")
  {
          element.onRowSelect = false;
          }
          else
            {
        let newRow = new SaveTransaction();
        newRow.PaymentTransID = element.paymentTransID;
        newRow.Isprocessed = "true";
        this.selectedTransactionMap.set(element.paymentTransID, newRow);
        if (newRow.PaymentTransID != null && selectedItems.length > 0) 
        { this.SavetransBtn = true; }
}
      }
  );

    }
  }
  //   1234 Checkbox
  onTransactionRowSelect(event,selectedItems) {
    if(event.target.checked){
    this.Saveselectedtransitems.push(selectedItems);

    if (this.selectedTransactionMap.size > 0) {
       this.selectedTransactionMap.clear();
     }
    if (selectedItems.type.length > 0) {
    this.Saveselectedtransitems.forEach(element => {
       // if (element.status == "Payment Processing")
         //{
         // element.onRowSelect = false;
          //}
         // else
            //{
           //   debugger;
        let newRow = new SaveTransaction();
        newRow.PaymentTransID = element.paymentTransID;
        //newRow.orderId = element.orderId;
        newRow.Isprocessed = "true";
        this.selectedTransactionMap.set(element.paymentTransID, newRow);
       // this.Saveselectedtransitems.set(selectedItems.paymentTransID, newRow);
       // debugger;
        if (newRow.PaymentTransID != null && selectedItems.type.length > 0) 
        { this.SavetransBtn = true; }
     // }
     }
 );
    }
  }
  
    else 
    {
      if (this.selectedTransactionMap.size > 0) {
        this.selectedTransactionMap.delete(selectedItems.paymentTransID);
      }
      if(this.selectedTransactionMap.size === 0)
      {
       this.SavetransBtn=false;
      }
    }
  }
  //}
//   1234 on check show all prossed trans
  onShowTransChecked(event)
   {     
    //debugger;
   // sessionStorage.setItem('comissioncheckbox', JSON.stringify(this.isCheckedAgency));
    console.log(event.target.checked);
    if (event.target.checked === false) {
      this.isshowtransChecked = false;
      this.LoadTransaction(this.isshowtransChecked);
    } else {
      //this.isCheckedAgency = true;
      this.isshowtransChecked = true;
      this.LoadTransaction(this.isshowtransChecked);
    }
    // Addde to have in session.
    //this.isCheckedAgency = JSON.parse(sessionStorage.getItem('isChecked'));
  }
  checkAll(event){
    debugger;
 if (this.transaction.length > 0) {
  this.transaction.forEach(item => {
  if(event){
    item.checkedbox = true;
    this.SavetransBtn = true;
    } else {
      item.checkedbox =false;
      this.SavetransBtn = false;
     // this.onRowTransactionUnselect(event);
     }
     });
     //debugger;
    this.selection = this.transaction;
    //   7/26
         if(!event)//{
      this.selection = [];
     // this.Saveselectedtransitems.push(this.selection);
     if (this.Saveselectedtransitems.size > 0) {
      this.Saveselectedtransitems.clear();
    }
     //this.Saveselectedtransitems.push(this.selection);
    if (this.selection.length > 0) {
      this.selection.forEach(element => {
          if (element.status == "Payment Processing")
           {
            element.onRowSelect = false;
            }
            else
              {
          let newRow = new SaveTransaction();
          newRow.PaymentTransID = element.paymentTransID;
          newRow.Isprocessed = "true";
          this.selectedTransactionMap.set(element.paymentTransID, newRow);
         // this.Saveselectedtransitems.set(selectedItems.paymentTransID, newRow);
          //debugger;
          if (newRow.PaymentTransID != null) 
          { this.SavetransBtn = true; }
        }
       }
   );
  }
  //  }
    console.log(this.selection);
  //}
  //this.onTransactionRowSelect(selectedItems)
 }


}
}
